import { defineStore } from 'pinia'
import { BREADCRUMB_STORE_ID } from '../constants'
import type { MenuBreadcrumb } from '../entities/MenuBreadcrumb'
import type { MenuBreadcrumbItems } from '../entities/MenuBreadcrumbItems'

export const useMenuBreadcrumbStore = defineStore(BREADCRUMB_STORE_ID, {
  state: (): { breadCrumbMenu: MenuBreadcrumb } => ({
    breadCrumbMenu: [],
  }),
  getters: {
    getMenuBreadcrumb(): MenuBreadcrumb {
      return this.breadCrumbMenu
    },
  },
  actions: {
    setMenuBreadcrumb(
      currentPageName: string,
      middleItems?: MenuBreadcrumbItems,
    ) {
      const route = useRoute()
      const breadcrumbMenu: MenuBreadcrumb = []
      // First Element
      breadcrumbMenu.push({
        id: 'home',
        name: t('menu.breadcrumb.home'),
        href: routes().home(),
        selected: false,
      })
      // Middle Items
      if (middleItems) {
        middleItems.forEach((item, index) => {
          breadcrumbMenu.push({
            id: `item-${index}`,
            name: item.name,
            href: item.href,
            selected: false,
          })
        })
      }

      // Last Element --> Current Page
      breadcrumbMenu.push({
        id: 'current-page',
        name: currentPageName,
        href: route.path,
        selected: true,
      })

      this.breadCrumbMenu = breadcrumbMenu
    },
  },
})
